import { FC, Fragment } from "react";
import { SvgIconOwnProps } from "@mui/material/SvgIcon/SvgIcon";
import { ListItemIcon, MenuItem, Typography } from "@mui/material";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import { ResourceExplorerCsvDownloaderTrigger } from "@/components/pages/resource-explorer/components/resource-explorer-card/components/billing-explorer-data-grid/components/csv/ResourceExplorerCsvDownloaderTrigger";
import { useDialog } from "@/utils/hooks/useDialog.hook";
import { CsvDownloadDialog } from "@/components/pages/resource-explorer/components/resource-explorer-card/components/billing-explorer-data-grid/components/csv-v2/dialog/CsvDownloadDialog";
import { useAppSelector } from "@/store/hooks";
import { resourceExplorerCsvDownloadLoadingSelector } from "@/store/resource-explorer/selectors/current-resource-explorer/csv/resourceExplorerCsvDownloadLoadingSelector";
import { billingExplorerIsCsvLoadingEnabledSelector } from "@/store/resource-explorer/selectors/current-resource-explorer/csv/billingExplorerIsCsvLoadingEnabledSelector";

interface ResourceExplorerCsvDownloaderV2Props {
  trigger?: "button" | "menuItem";
  color?: SvgIconOwnProps["color"];
  onClose?(): void;
}

export const ResourceExplorerCsvDownloaderV2: FC<
  ResourceExplorerCsvDownloaderV2Props
> = ({ trigger, color, onClose }) => {
  const { open, openDialog, closeDialog } = useDialog();

  const isCsvLoadEnabled = useAppSelector(
    billingExplorerIsCsvLoadingEnabledSelector,
  );
  const preparingLoading = useAppSelector(
    resourceExplorerCsvDownloadLoadingSelector,
  );
  const closeHandler = () => {
    closeDialog();
    onClose?.();
  };

  if (trigger === "menuItem") {
    return (
      <Fragment>
        <MenuItem
          onClick={openDialog}
          disabled={!isCsvLoadEnabled || preparingLoading}
        >
          <ListItemIcon>
            <DownloadOutlinedIcon fontSize="small" color={color} />
          </ListItemIcon>

          <Typography variant="body2" color="text.primary">
            Export CSV
          </Typography>
        </MenuItem>

        {open && <CsvDownloadDialog open={open} onClose={closeHandler} />}
      </Fragment>
    );
  }

  return (
    <Fragment>
      <ResourceExplorerCsvDownloaderTrigger
        onClick={openDialog}
        disabled={!isCsvLoadEnabled || preparingLoading}
        trigger="button"
        color={color}
      />

      {open && <CsvDownloadDialog open={open} onClose={closeHandler} />}
    </Fragment>
  );
};
